import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  stockHoldNo: {
    name: "stockHoldNo",
    label: "Stock Hold No",
    type: "text",
    editable: false,
    disabled: true, 
    maxLength: 20,
    xs: 3,
  },
  remark: {
    type: "text", name: "remark", label: "Remark", maxLength: 250, edit: true
  },
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    maxLength: 20,
    xs: 3,
    edit: true,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    xs: 3,
    edit: true,
  },
  reasonCode: {
    name: "reasonCode",
    label: "Reason",
    type: "text",
    errorMsg: "Reason is required",
    required: true,
    maxLength: 20,
    xs: 3,
    edit: true,
  },
};

const { stockHoldNo, remark, warehouseCode, customerCode, reasonCode } = formField;

export const formRender = [[stockHoldNo, customerCode, warehouseCode, reasonCode], [remark]];

export const initialValues = getInitialValues(formField);

export const stockHoldValidation = Yup.object().shape({
  [stockHoldNo.name]: Yup.string().nullable().max(stockHoldNo.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
  [warehouseCode.name]: Yup.string().nullable().max(warehouseCode.maxLength).required(warehouseCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [reasonCode.name]: Yup.string().nullable().required(reasonCode.errorMsg).max(reasonCode.maxLength),
});
